<template>
  <div class="site">
    <ul
      class="site__menu site__menu--color site__menu--text site__menu--mt"
    >
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SiteDesktop',
  data: function () {
    return {
      investment: `/`
    }
  },
  methods: {
    clearStorage: function () {
      sessionStorage.clear()
    }
  }
}
</script>

<style lang="scss" scoped>

@media (min-width: 1024px) {

  .site__menu {
    list-style-type: none;
    padding: 0;
    margin: 1.5em;
    display: flex;
  }

  .site__menu--mt {
    margin-top: 2em;
  }

  .site__item--ml {
    margin-left: 2em;
  }

  .site__menu--text {
    font-size: .9em;
    font-weight: 400;
  }

  .site__menu--color {
    color: $white;
  }

  .site__item--cursor {
    cursor: pointer;
    transition-duration: 0.5s;
  }

  .site__item__about:hover .about-us__menu {
    display: block;
  }

  .about-us__menu {
    display: none;
    position: absolute;
    margin-top: 0;
    margin-right: 9em;
    transition: all 0.5s ease;
    background: $midnight-blue;
    padding: 1em;
    border-radius: .5em;
    color: $white;
  }

  .about-us__item:hover {
    font-weight: bold;
  }

  .about-us__item:hover::before,
  .about-us__link--active::before {
    content: '';
    width: 6%;
    height: 20px;
    position: absolute;
    left: 0;
    background: $green;
  }

  .site__link--color,
  .about-us__link--color {
    color: $white;
  }

  .site__item__about:hover::before,
  .site__link:hover::before,
  .site__link--active::before {
    content: '';
    height: 8px;
    width: 4%;
    background: #ffffff;
    position: absolute;
    bottom: 20px;
    opacity: .8;
    border-radius: .5em;
    transition: all .3s ease;
  }

  .site__item__about:hover {
    color: $midnight-blue;
  }

  .site__item__about:hover::before {
    width: 2%;
    background: $midnight-blue;
    opacity: 1;
  }

  .site__item::before,
  .about-us__item::before {
    content: ' ';
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation/Menu/Desktop/SiteDesktop.vue